<template>
  <div class="mb-5">
    <MarketOverallOverviewComponent :isMainLoading="isMainLoading" :tabType="tab"/>
  </div>
</template>

<script>
import MarketOverallOverviewComponent from "@/components/MarketOverallOverview.component";
export default {
  components: {
    MarketOverallOverviewComponent
  },
  props: {
    isMainLoading: Boolean
  },
  data() {
    return {
      tab: this.$globalCurrencyCode
    }
  },
};
</script>